import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {
  notificationMutations,
  notificationActions,
  initialNotificationsState,
  notificationGetters
} from '@/store/Notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
    loginWarnings: localStorage.getItem('loginWarnings') ? JSON.parse(localStorage.getItem('loginWarnings')) : [],
    authConfig: localStorage.getItem('authConfig') ? JSON.parse(localStorage.getItem('authConfig')) : {},
    logicoins: 0,
    ...initialNotificationsState
  },
  mutations: {
    ...notificationMutations,
    auth_request (state) {
      state.status = 'loading'
    },
    auth_success (state, { token, user, warnings }) {
      state.status = 'success'
      state.token = token
      state.user = user
      state.loginWarnings = warnings
    },
    auth_error (state) {
      state.status = 'error'
    },
    logout (state) {
      state.status = ''
      state.token = ''
      state.user = {}
      state.loginWarnings = []
      state.authConfig = {}
    },
    auth_config (state, { config }) {
      state.authConfig = config
    },
    auth_config_Error (state) {
      state.authConfig = {}
    },
    auth_logout_request (state) {
      state.status = 'loading'
    },
    auth_logout_error (state) {
      state.status = ''
      state.token = ''
      state.user = {}
      state.loginWarnings = []
      state.authConfig = {}
    },
    user_accept_terms (state, { id }) {
      state.user.term_and_condition_id = id
    },
    upload_image_profile (state, { profilePicture }) {
      state.user.profile_picture = profilePicture
    }
  },
  actions: {
    ...notificationActions,
    login ({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios.post(`${process.env.VUE_APP_API_URL}/auth/login`, credentials, { headers: { 'x-app': 'B2C' } })
          .then(response => {
            const token = response.data.access_token
            const warnings = response.data.warnings
            const user = response.data.user
            localStorage.setItem('token', token)
            localStorage.setItem('loginWarnings', JSON.stringify(warnings))
            localStorage.setItem('user', JSON.stringify(user))
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit('auth_success', { token, user, warnings })
            resolve(response.data)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            localStorage.removeItem('loginWarnings')
            localStorage.removeItem('user')
            reject(err)
          })
      })
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('auth_logout_request')
        axios.post(`${process.env.VUE_APP_API_URL}/auth/logout`)
          .then(() => {
            commit('logout')
            localStorage.removeItem('token')
            localStorage.removeItem('loginWarnings')
            localStorage.removeItem('user')
            localStorage.removeItem('authConfig')
            delete axios.defaults.headers.common['Authorization']
            resolve()
          })
          .catch(err => {
            commit('auth_logout_error')
            localStorage.removeItem('token')
            localStorage.removeItem('loginWarnings')
            localStorage.removeItem('user')
            localStorage.removeItem('authConfig')
            delete axios.defaults.headers.common['Authorization']
            reject(err)
          })
      })
    },
    acceptTerms ({ commit }, termsId) {
      return new Promise((resolve, reject) => {
        commit('user_accept_terms', { id: termsId })
        const token = localStorage.getItem('token')
        axios.put(`${process.env.VUE_APP_API_URL}/terms-and-conditions/${termsId}/accept`, {
          headers: {
            'x-app': 'B2C',
            'Authorization': 'Bearer ' + token
          }
        })
          .then(resp => {
            const user = JSON.parse(localStorage.getItem('user'))
            user.term_and_condition_id = termsId
            // localStorage.removeItem('user')
            localStorage.setItem('user', JSON.stringify(user))
            resolve(resp.data)
          })
          .catch(reject)
      })
    },
    authConfig ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get(`${process.env.VUE_APP_API_URL}/auth/config`)
          .then(response => {
            localStorage.setItem('authConfig', JSON.stringify(response.data))
            commit('auth_config', { config: response.data })
            resolve()
          })
          .catch(err => {
            commit('auth_config_error')
            localStorage.removeItem('authConfig')
            reject(err)
          })
      })
    },
    updateImage ({ commit }, image) {
      commit('upload_image_profile', image)
      const user = JSON.parse(localStorage.getItem('user'))
      user.profile_picture = image
      localStorage.setItem('user', JSON.stringify(user))
    }
  },
  getters: {
    userPermissions: state => {
      return state.user.permissions
    },
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    token: state => state.token,
    userLogged: state => state.user,
    hasLoginWarnings: state => state.loginWarnings.length > 0,
    loginWarnings: state => state.loginWarnings,
    logicoins: state => state.user.client.logicoins,
    authConfig: state => state.authConfig,
    ...notificationGetters
  }
})
